import { sanitize } from "dompurify";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { EventType } from "../balancing/types/BalancingCore";
import { IdIcon } from "../generic/icon/IdIcon";
export var placementLeaguesInfo = [
    {
        idBackgroundStyle: IdStyles.LeagueContentBronze,
        idMedalIcon: new Map([
            [EventType.CoopLeague, IdIcon.LeagueCoopMedal0Icn],
            [EventType.PlayerLeague, IdIcon.LeaguePlayerMedal0Icn],
            [EventType.CollectLeague, IdIcon.LeagueCollectMedal0Icn],
        ]),
        idNameLoca: IdLoca.league0,
        idSelectedBackgroundStyle: IdStyles.LeagueContentBronzeSelected,
        startsFrom: 0,
    },
    {
        idBackgroundStyle: IdStyles.LeagueContentSilver,
        idMedalIcon: new Map([
            [EventType.CoopLeague, IdIcon.LeagueCoopMedal1Icn],
            [EventType.PlayerLeague, IdIcon.LeaguePlayerMedal1Icn],
            [EventType.CollectLeague, IdIcon.LeagueCollectMedal1Icn],
        ]),
        idNameLoca: IdLoca.league1,
        idSelectedBackgroundStyle: IdStyles.LeagueContentSilverSelected,
        startsFrom: 3,
    },
    {
        idBackgroundStyle: IdStyles.LeagueContentGold,
        idMedalIcon: new Map([
            [EventType.CoopLeague, IdIcon.LeagueCoopMedal2Icn],
            [EventType.PlayerLeague, IdIcon.LeaguePlayerMedal2Icn],
            [EventType.CollectLeague, IdIcon.LeagueCollectMedal2Icn],
        ]),
        idNameLoca: IdLoca.league2,
        idSelectedBackgroundStyle: IdStyles.LeagueContentGoldSelected,
        startsFrom: 6,
    },
    {
        idBackgroundStyle: IdStyles.LeagueContentEmerald,
        idMedalIcon: new Map([
            [EventType.CoopLeague, IdIcon.LeagueCoopMedal3Icn],
            [EventType.PlayerLeague, IdIcon.LeaguePlayerMedal3Icn],
            [EventType.CollectLeague, IdIcon.LeagueCollectMedal3Icn],
        ]),
        idNameLoca: IdLoca.league3,
        idSelectedBackgroundStyle: IdStyles.LeagueContentEmeraldSelected,
        startsFrom: 9,
    },
    {
        idBackgroundStyle: IdStyles.LeagueContentSapphire,
        idMedalIcon: new Map([
            [EventType.CoopLeague, IdIcon.LeagueCoopMedal4Icn],
            [EventType.PlayerLeague, IdIcon.LeaguePlayerMedal4Icn],
            [EventType.CollectLeague, IdIcon.LeagueCollectMedal4Icn],
        ]),
        idNameLoca: IdLoca.league4,
        idSelectedBackgroundStyle: IdStyles.LeagueContentSapphireSelected,
        startsFrom: 12,
    },
];
export var placementDivisions = [0, 1, 2];
export var convertLeagueIdToReplacements = function (leagueId) {
    var numberOfLeagues = placementLeaguesInfo.length;
    var numberOfDivisions = placementDivisions.length;
    var maxLeagues = numberOfLeagues * numberOfDivisions;
    if (leagueId < 0 || leagueId > maxLeagues) {
        return new Map();
    }
    var division = ((leagueId % numberOfDivisions) + 1).toString();
    // Re-sorting the array in case in the future
    var league = placementLeaguesInfo[Math.floor(leagueId / numberOfDivisions)].idNameLoca;
    return new Map([
        [ReplacementLoca.zero_0, sanitize(utilLoca.get(league))],
        [ReplacementLoca.one_1, division],
    ]);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/IdLeaguePlacement.ts
// module id = 946
// module chunks = 3